import React from 'react';
import FactorTabLayout from '../shared/FactorTabLayout';
import { getTab } from '../config';

/**
 * Global events and risk factors.
 *
 * Currently the shared factor layout with nothing extra. Add tab-specific
 * sections as children of FactorTabLayout - they stay isolated to this file.
 */
const GeopoliticalTab = ({ data, period }) => (
  <FactorTabLayout tab={getTab('geopolitical')} data={data} period={period} />
);

export default GeopoliticalTab;
